import { AdMob, AdmobConsentStatus } from "@capacitor-community/admob";
import { Capacitor } from "@capacitor/core";
import { useEffect } from "react";

export default function InitializeAdMob() {
  useEffect(() => {
    const platform = Capacitor.getPlatform();

    if (platform === "android" || platform === "ios") {
      doTheInitialization();
    }
  }, []);

  async function doTheInitialization() {
    await AdMob.initialize({
      requestTrackingAuthorization: true, // for ios
      testingDevices: [
        "4b8aeb3f-ccf3-4ecc-9d92-43f319d9f415",
        "5b88a9a7-6645-45cb-9c17-491917ce1e6b",
      ],
      initializeForTesting: true,
    });

    const [trackingInfo, consentInfo] = await Promise.all([
      AdMob.trackingAuthorizationStatus(),
      AdMob.requestConsentInfo(),
    ]);

    if (trackingInfo.status === "notDetermined") {
      /**
       * If you want to explain TrackingAuthorization before showing the iOS dialog,
       * you can show the modal here.
       * ex)
       * const modal = await this.modalCtrl.create({
       *   component: RequestTrackingPage,
       * });
       * await modal.present();
       * await modal.onDidDismiss();  // Wait for close modal
       **/

      await AdMob.requestTrackingAuthorization();
    }

    const authorizationStatus = await AdMob.trackingAuthorizationStatus();
    if (
      authorizationStatus.status === "authorized" &&
      consentInfo.isConsentFormAvailable &&
      consentInfo.status === AdmobConsentStatus.REQUIRED
    ) {
      await AdMob.showConsentForm();
    }
  }
}
